import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function saldoCotaOrgaoLista(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@saldoCotaOrgaoLista/FIND_DATA':
      case '@saldoCotaOrgaoLista/UPDATE_DATA':
      case '@saldoCotaOrgaoLista/DELETE_DATA':
      case '@saldoCotaOrgaoLista/STORE_DATA':
      case '@saldoCotaOrgaoLista/DATA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@saldoCotaOrgaoLista/SUCCESS_REMOVE':
      case '@saldoCotaOrgaoLista/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@saldoCotaOrgaoLista/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.data;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@saldoCotaOrgaoLista/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.data;
        break;
      }

      case '@saldoCotaOrgaoLista/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
